import {
  GET_ALL_DOCTORS_REQUEST,
  GET_ALL_DOCTORS_SUCCESS,
  GET_ALL_DOCTORS_FAIL,
  DOCTOR_FILTER,
  SUBMIT_COUPON_SUCCESS,
  SUBMIT_COUPON_FAIL,
  UPDATE_COUPON_SUCCESS,
  UPDATE_COUPON_FAIL,
  DELETE_COUPON_REQUEST,
  DELETE_COUPON_SUCCESS,
  DELETE_COUPON_FAIL
} from '../actions/types';

const initialCouponsState = {
  coupons: [],
  loading: false,
  error: null,
};

const initialServicesState = {
  services: [],
  loading: false,
  error: null,
};

// const initialSpecializationState = {
//   specialization: [],
//   loading: false,
//   error: null,
// };

const initialState = {
  doctors: [],
  filteredDoctors:[],
  location: '',
  query: '',
  profileData: null,   

  loading: false,
  error: null,
};

  
  // Utility to create simple reducers
  const createReducer = (successType, failType) => (state = initialState, action) => {
    switch (action.type) {
      case successType.replace('SUCCESS', 'REQUEST'):
        return { ...state, loading: true };
      case successType:
        return { loading: false, success: true, error: null };
      case failType:
        return { loading: false, success: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export const profileReducer = createReducer(
    'SUBMIT_PROFILE_SUCCESS',
    'SUBMIT_PROFILE_FAIL'
  );
  
  export const clinicImagesReducer = (
    state = { clinicImages: [], loading: false, error: null },
    action
  ) => {
    switch (action.type) {
      case 'UPLOAD_CLINIC_IMAGES_REQUEST':
        return { ...state, loading: true };
      case 'UPLOAD_CLINIC_IMAGES_SUCCESS':
        return {
          ...state,
          loading: false,
          clinicImages: [...state.clinicImages, ...(Array.isArray(action.payload) ? action.payload : [action.payload])],
          error: null,
        };
      case 'UPLOAD_CLINIC_IMAGES_FAIL':
        return { ...state, loading: false, error: action.payload };
  
      case 'DELETE_CLINIC_IMAGE_SUCCESS':
        return {
          ...state,
          clinicImages: state.clinicImages.filter(img => img.id !== action.payload),
          error: null,
        };
      case 'DELETE_CLINIC_IMAGE_FAIL':
        return {
          ...state,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  
  
  
  export const servicesReducer = (state = initialServicesState, action) => {
    switch (action.type) {
      case 'SUBMIT_SERVICES_REQUEST':
        return { ...state, loading: true };
  
      case 'SUBMIT_SERVICES_SUCCESS':
        return {
          ...state,
          loading: false,
          services: action.payload,
          error: null,
        };
  
      case 'SUBMIT_SERVICES_FAIL':
        return { ...state, loading: false, error: action.payload };
  
      case 'DELETE_SERVICE_SUCCESS':
        return {
          ...state,
          services: state.services.filter(s => s.id !== action.payload),
          error: null,
        };
  
      case 'DELETE_SERVICE_FAIL':
        return {
          ...state,
          error: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export const specializationReducer = (
    state = { specialization: [], loading: false, error: null },
    action
  ) => {
    switch (action.type) {
      case 'SUBMIT_SPECIALIZATION_REQUEST':
      case 'DELETE_SPECIALIZATION_REQUEST':
        return {
          ...state,
          loading: true,
          error: null,
        };
      case 'SUBMIT_SPECIALIZATION_SUCCESS':
        return {
          ...state,
          specialization: [
            ...state.specialization,
            ...(Array.isArray(action.payload) ? action.payload : [action.payload]),
          ],
          loading: false,
          error: null,
        };
      case 'DELETE_SPECIALIZATION_SUCCESS':
        return {
          ...state,
          specialization: state.specialization.filter(item => item.id !== action.payload),
          loading: false,
          error: null,
        };
      case 'SUBMIT_SPECIALIZATION_FAIL':
      case 'DELETE_SPECIALIZATION_FAIL':
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  
  export const educationReducer = (
    state = { education: [], loading: false, error: null },
    action
  ) => {
    switch (action.type) {
      case 'SUBMIT_EDUCATION_REQUEST':
      case 'DELETE_EDUCATION_REQUEST':
        return { ...state, loading: true, error: null };
  
      case 'SUBMIT_EDUCATION_SUCCESS':
        return {
          ...state,
          education: [
            ...state.education,
            ...(Array.isArray(action.payload) ? action.payload : [action.payload]),
          ],
          loading: false,
          error: null,
        };
  
      case 'DELETE_EDUCATION_SUCCESS':
        return {
          ...state,
          education: state.education.filter(item => item.id !== action.payload),
          loading: false,
          error: null,
        };
  
      case 'SUBMIT_EDUCATION_FAIL':
      case 'DELETE_EDUCATION_FAIL':
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export const experienceReducer = (
    state = { experience: [], loading: false, error: null },
    action
  ) => {
    switch (action.type) {
      case 'SUBMIT_EXPERIENCE_REQUEST':
      case 'DELETE_EXPERIENCE_REQUEST':
        return { ...state, loading: true, error: null };
  
      case 'SUBMIT_EXPERIENCE_SUCCESS':
        return {
          ...state,
          experience: [
            ...state.experience,
            ...(Array.isArray(action.payload) ? action.payload : [action.payload]),
          ],
          loading: false,
          error: null,
        };
  
      case 'DELETE_EXPERIENCE_SUCCESS':
        return {
          ...state,
          experience: state.experience.filter(item => item.id !== action.payload),
          loading: false,
          error: null,
        };
  
      case 'SUBMIT_EXPERIENCE_FAIL':
      case 'DELETE_EXPERIENCE_FAIL':
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export const awardsReducer = (
    state = { awards: [], loading: false, error: null },
    action
  ) => {
    switch (action.type) {
      case 'SUBMIT_AWARDS_REQUEST':
      case 'DELETE_AWARD_REQUEST':
        return { ...state, loading: true, error: null };
  
      case 'SUBMIT_AWARDS_SUCCESS':
        return {
          ...state,
          awards: [
            ...state.awards,
            ...(Array.isArray(action.payload) ? action.payload : [action.payload]),
          ],
          loading: false,
          error: null,
        };
  
      case 'DELETE_AWARD_SUCCESS':
        return {
          ...state,
          awards: state.awards.filter(item => item.id !== action.payload),
          loading: false,
          error: null,
        };
  
      case 'SUBMIT_AWARDS_FAIL':
      case 'DELETE_AWARD_FAIL':
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export const membershipsReducer = (
    state = { memberships: [], loading: false, error: null },
    action
  ) => {
    switch (action.type) {
      case 'SUBMIT_MEMBERSHIPS_REQUEST':
      case 'DELETE_MEMBERSHIP_REQUEST':
        return { ...state, loading: true, error: null };
  
      case 'SUBMIT_MEMBERSHIPS_SUCCESS':
        return {
          ...state,
          memberships: [
            ...state.memberships,
            ...(Array.isArray(action.payload) ? action.payload : [action.payload]),
          ],
          loading: false,
          error: null,
        };
  
      case 'DELETE_MEMBERSHIP_SUCCESS':
        return {
          ...state,
          memberships: state.memberships.filter(item => item.id !== action.payload),
          loading: false,
          error: null,
        };
  
      case 'SUBMIT_MEMBERSHIPS_FAIL':
      case 'DELETE_MEMBERSHIP_FAIL':
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  
  export const registrationsReducer = (
    state = { registrations: [], loading: false, error: null },
    action
  ) => {
    switch (action.type) {
      case 'SUBMIT_REGISTRATIONS_REQUEST':
      case 'DELETE_REGISTRATION_REQUEST':
        return { ...state, loading: true, error: null };
  
      case 'SUBMIT_REGISTRATIONS_SUCCESS':
        return {
          ...state,
          registrations: [
            ...state.registrations,
            ...(Array.isArray(action.payload) ? action.payload : [action.payload]),
          ],
          loading: false,
          error: null,
        };
  
      case 'DELETE_REGISTRATION_SUCCESS':
        return {
          ...state,
          registrations: state.registrations.filter(item => item.id !== action.payload),
          loading: false,
          error: null,
        };
  
      case 'SUBMIT_REGISTRATIONS_FAIL':
      case 'DELETE_REGISTRATION_FAIL':
        return { ...state, loading: false, error: action.payload };
  
      default:
        return state;
    }
  };
  

  
 
  
  
  export const doctorListReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_ALL_DOCTORS_REQUEST:
        return { ...state, loading: true };
        case GET_ALL_DOCTORS_SUCCESS:
          return {
            ...state,
            doctors: action.payload.data,
            loading: false,
            error: null
          };
      case GET_ALL_DOCTORS_FAIL:
        return { ...state, loading: false, error: action.payload };
        case DOCTOR_FILTER:
      return { ...state, filteredDoctors: action.payload.data ,
        location:action.payload.location,
        query:action.payload.query
      
      };
      default:
        return state;
    }
  };
  



  export const couponsReducer = (state = initialCouponsState, action) => {
    switch (action.type) {
      // --- CASES FOR CREATING & UPDATING ---
      
      case 'SUBMIT_COUPON_SUCCESS':
        // Adds a new coupon to the state array
        return {
          ...state,
          coupons: [...state.coupons, action.payload], // Assuming payload is the new coupon object
          loading: false,
          error: null,
        };
  
      case 'UPDATE_COUPON_SUCCESS':
        // Finds the existing coupon by its ID and replaces it with the updated version
        return {
          ...state,
          coupons: state.coupons.map(coupon => 
            coupon.id === action.payload.id ? action.payload : coupon
          ),
          loading: false,
          error: null,
        };
  
      // --- CASES FOR DELETING ---
  
      case DELETE_COUPON_REQUEST:
        return { 
          ...state, 
          loading: true, 
          error: null 
        };
  
      case DELETE_COUPON_SUCCESS:
        // Filters out the deleted coupon from the state array
        return {
          ...state,
          coupons: state.coupons.filter(item => item.id !== action.payload), // Payload should be the ID of the deleted coupon
          loading: false,
          error: null,
        };
  
      // --- CASES FOR HANDLING ERRORS ---
  
      case SUBMIT_COUPON_FAIL:
      case UPDATE_COUPON_FAIL:
      case DELETE_COUPON_FAIL:
        return { 
          ...state, 
          loading: false, 
          error: action.payload 
        };
  
      default:
        return state;
    }
  };